var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowTopRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 12.59 10.59 2H4V0h10v10h-2V3.41L1.41 14 0 12.59Z",
  fill: "currentColor"
})));
export { SvgArrowTopRight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNiAxNiI+CiAgICA8ZyBpZD0iQXJyb3dUb3BSaWdodCIgZmlsbD0iY3VycmVudENvbG9yIj4KICAgICAgICA8cGF0aCBkPSJtMCwxMi41OUwxMC41OSwyaC02LjU5VjBoMTB2MTBoLTJWMy40MUwxLjQxLDE0bC0xLjQxLTEuNDFaIiAvPgogICAgPC9nPgo8L3N2Zz4K";